module.exports = __webpack_public_path__ + "static/media/uy.79b02850.svg";